import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import EditorApp from "./components/HotspotEditor/EditorApp";

import './i18n/config';
import "./base/reset.scss";
import "./base/mixins.scss";
import "./base/constants.scss";

// Check if editor is enabled via environment variable
// The editor is available in development mode or when REACT_APP_ENABLE_EDITOR is true
const isEditorEnabled = process.env.REACT_APP_ENV === 'development' || 
                        process.env.REACT_APP_ENABLE_EDITOR === 'true';

// Check if ?editor query param is present
const urlParams = new URLSearchParams(window.location.search);
const isEditorMode = urlParams.has('editor');

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

// Render editor if ?editor is in URL and editor is enabled, otherwise render normal app
root.render(
   // <React.StrictMode>
   (isEditorMode && isEditorEnabled) ? <EditorApp /> : <App />
   // </React.StrictMode>
);
